//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[[0,"RevisionRule",1,0]],[[["requirement"],"CreateRequirementBuilder",{R_:{builder:"Validate.RequirementBuilder"}},1,0],[["id"],"FindObject",{R_:{requirement:"Validate.Requirement"}},1,0],[["sourceType","source","revision","project"],"LoadFromExternalSource",{},4,0],[["requirementTags"],"RefreshFromExternalSource",{},1,0]],[]];
SPLM.Validate.RequirementCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Validate.RequirementCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Validate.RequirementCollection.SourceTypeOptions = Object.freeze({
    "LocalFile" : "LocalFile", "TeamcenterFile" : "TeamcenterFile", "Teamcenter" : "Teamcenter", "MeasurableAttribute" : "MeasurableAttribute"});

export default SPLM;